import { render, staticRenderFns } from "./UserAnnouncementList.vue?vue&type=template&id=7fac4602&scoped=true&"
import script from "./UserAnnouncementList.vue?vue&type=script&lang=js&"
export * from "./UserAnnouncementList.vue?vue&type=script&lang=js&"
import style0 from "./UserAnnouncementList.vue?vue&type=style&index=0&id=7fac4602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac4602",
  null
  
)

export default component.exports